module.exports = __webpack_public_path__ + "static/assets/b987c9e2c37b17bd7c97f1fa47257d7e.svg";